var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 39.291 39.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5726",
    "data-name": "Group 5726",
    transform: "translate(-1306.221 -490.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Equalizer_1_",
    d: "M49.78,32.572H31.431a6.016,6.016,0,0,0-11.66,0H13.511a1.511,1.511,0,1,0,0,3.022h6.259a6.016,6.016,0,0,0,11.66,0H49.78a1.511,1.511,0,0,0,0-3.022ZM25.6,37.106a3.022,3.022,0,1,1,3.022-3.022A3.025,3.025,0,0,1,25.6,37.106Z",
    transform: "translate(1294.221 489.296)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Equalizer_1_2",
    "data-name": "Equalizer_1_",
    d: "M49.78,24.553H43.52a6.016,6.016,0,0,0-11.66,0H13.511a1.511,1.511,0,1,0,0,3.022H31.86a6.016,6.016,0,0,0,11.66,0H49.78a1.511,1.511,0,0,0,0-3.022ZM37.69,29.087a3.022,3.022,0,1,1,3.022-3.022A3.025,3.025,0,0,1,37.69,29.087Z",
    transform: "translate(1294.221 483.714)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Equalizer_1_3",
    "data-name": "Equalizer_1_",
    d: "M49.78,16.534H31.431a6.016,6.016,0,0,0-11.66,0H13.511a1.511,1.511,0,1,0,0,3.022h6.259a6.016,6.016,0,0,0,11.66,0H49.78a1.511,1.511,0,0,0,0-3.022ZM25.6,21.067a3.022,3.022,0,1,1,3.022-3.022A3.025,3.025,0,0,1,25.6,21.067Z",
    transform: "translate(1294.221 478.133)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomViews);
export default __webpack_public_path__ + "static/media/CustomViews.2e489f12b52e34f6753ae2adfbdf4853.svg";
export { ForwardRef as ReactComponent };